var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "admin-layout" } },
    [
      _c(
        "ma-modal",
        { ref: "adminImportModal", attrs: { type: "small" } },
        [
          _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              { staticClass: "modal__main" },
              [
                _c("p", { staticClass: "headline-large mg mg--b-3 black" }, [
                  _vm._v(_vm._s(_vm.$t("adminLayout.modals.import.title")))
                ]),
                _c("p", { staticClass: "text-medium mg mg--b-3" }, [
                  _vm._v(
                    _vm._s(_vm.$t("adminLayout.modals.import.description"))
                  )
                ]),
                _c("ma-input-file", {
                  staticClass: "mg mg--b-3",
                  attrs: {
                    name: "import-parameters",
                    label: _vm.$t("actions.selectFile")
                  },
                  on: {
                    change: _vm.handleImportInputChange,
                    delete: _vm.handleImportInputDelete
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "modal--actions mg mg--t-5" }, [
              _c(
                "button",
                {
                  staticClass: "mainBlue mg mg--r-2",
                  attrs: { disabled: !_vm.paramsFile || _vm.loadingImport },
                  on: { click: _vm.handleImportConfirm }
                },
                [_vm._v(_vm._s(_vm.$t("actions.import")))]
              ),
              _c(
                "button",
                {
                  staticClass: "secondaryBlue",
                  on: { click: _vm.handleImportCancel }
                },
                [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
              )
            ])
          ])
        ],
        2
      ),
      _c(
        "ma-modal",
        { ref: "adminExportModal", attrs: { type: "small" } },
        [
          _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              { staticClass: "modal__main" },
              [
                _c("p", { staticClass: "headline-large mg mg--b-1 black" }, [
                  _vm._v(_vm._s(_vm.$t("adminLayout.modals.export.title")))
                ]),
                _c("p", { staticClass: "text-medium mg mg--b-4" }, [
                  _vm._v(
                    _vm._s(_vm.$t("adminLayout.modals.export.description"))
                  )
                ]),
                _c("ma-filters", {
                  on: { "filter:change": _vm.handleFilterExportChange }
                })
              ],
              1
            ),
            _c("div", { staticClass: "modal--actions mg mg--t-5" }, [
              _c(
                "button",
                {
                  staticClass: "mainBlue mg mg--r-2",
                  on: { click: _vm.handleExportConfirm }
                },
                [_vm._v(_vm._s(_vm.$t("actions.export")))]
              ),
              _c(
                "button",
                {
                  staticClass: "secondaryBlue",
                  on: { click: _vm.handleExportCancel }
                },
                [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
              )
            ])
          ])
        ],
        2
      ),
      _c("div", { staticClass: "grid grid--jc-bottom mg mg--b-4" }, [
        _c(
          "button",
          { staticClass: "mainYellow", on: { click: _vm.handleImportClick } },
          [_vm._v(_vm._s(_vm.$t("actions.import")))]
        ),
        _c(
          "button",
          {
            staticClass: "mainYellow mg mg--l-2",
            on: { click: _vm.handleExportClick }
          },
          [_vm._v(_vm._s(_vm.$t("actions.export")))]
        ),
        _c(
          "button",
          {
            staticClass: "mainYellow mg mg--l-2",
            on: { click: _vm.handleExportAllClick }
          },
          [_vm._v(_vm._s(_vm.$t("actions.exportAll")))]
        )
      ]),
      _c("ma-tab-nav", { attrs: { items: _vm.dataUserRoutes } }),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [_c("router-view")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }